var valida_rut=function(value)
{   
    value=value.toString().split('.').join('');
    value=value.toString().split('-').join('');
    value=value.toString().split(',').join('');
    
    var tmpstr = "";
    var intlargo = value;
    if (intlargo.length> 0)
    {
        var crut = value;
        var largo = crut.length;
        if ( largo <2 ){
            value='rut inválido';
            return false;
        }
        for (var i=0; i <crut.length ; i++ ){
            if ( crut.charAt(i) != ' ' && crut.charAt(i) != '.' && crut.charAt(i) != '-' ){
                    tmpstr = tmpstr + crut.charAt(i);
            }
        }
            

        var rut = tmpstr; 
        crut=tmpstr;
        largo = crut.length;
        if ( largo> 2 )
            rut = crut.substring(0, largo - 1);
        else
            rut = crut.charAt(0); 

        var dv = crut.charAt(largo-1);
        if ( rut == null || dv == null ){
            return 0;
        }
        
            
        var dvr = '0';
        var suma = 0;
        var mul  = 2;
        for (var i= rut.length-1 ; i>= 0; i--)
        {
            suma = suma + rut.charAt(i) * mul;
            if (mul == 7)
                mul = 2;
            else
                mul++;
        }
        var res = suma % 11;
        if (res==1)
            dvr = 'k';
        else if (res==0)
            dvr = '0';
        else
        {
            var dvi = 11-res;
            dvr = dvi + "";
        }
        

        if ( dvr != dv.toLowerCase() )
        { 
            value='El Rut Ingreso es Invalido';
            return false;
        }
        else{
            value=rut.toString() + '-' + dvr.toString();         
            return true;
        } 
        
    }
    else{
        return false;
    }
}

export default
{
    valida_rut

}